module.exports = __webpack_public_path__ + "media/images/application/template/cta_meat_01-c1f8693789fb83bee64960a077b8d108.svg";